import {useMutation, useQueryClient} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {useModal} from "../../../../../hooks";
import {OrdersDetailSubjectElementType} from "../interface";
import {readOrderSubjects, saveOrderSubjects} from "../../../../../api/order/OrdersApi";
import {useSetAtom} from "jotai/index";
import {isLoading} from "../../../../../state/Spinner";

export const useSaveOrderSubjects = ({closeCallback}: { closeCallback: () => any }) => {
    const setLoading = useSetAtom(isLoading);

    const {handleModal} = useModal();
    const qc = useQueryClient()

    const {mutate, mutateAsync} = useMutation({
        mutationFn: (data: OrdersDetailSubjectElementType[]) => saveOrderSubjects(data),
        onSuccess: (res) => {
            const data = res.data

            if (data.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: "수정되었습니다.",
                    type: "alert",
                    closeAction: () => {
                        qc.invalidateQueries({queryKey: ["readShipmentDetail"]})
                        qc.invalidateQueries({queryKey: ["readOrderSubjects"]})
                        closeCallback()
                    }
                });
            } else {
                console.log('error: ', res)
                handleModal({
                    isOpen: true,
                    contents: (data as any).message,
                    type: "alert",
                });
            }
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
        onMutate: () => setLoading(true),
        onSettled: () => setLoading(false)
    });

    return {mutate, mutateAsync};
};
